import { useGroupsContext } from '@fs/zion-tree-groups'
import Subnav from '@fs/zion-tree-subnav-legacy'
import { colors } from '@fs/zion-ui'
import React from 'react'
import { useLocation } from '@fs/zion-router'
import SubnavLoading from './SubnavLoading'

// Maps root paths (with or without trailing slash) to their subnav page name
const subNavPageMap = {
  '/family': 'family',
  '/research-tree': 'research-tree',
  '/trees': 'manage-trees',
}

export function SubnavWrapper() {
  const { groups, currentTreeId, selectTree, loading } = useGroupsContext()
  const { pathname } = useLocation()
  // Strip trailing slash so /trees, /trees/, /family, /family/, etc. all match
  const normalizedPath = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname
  const subNavPage = subNavPageMap[normalizedPath] ?? null

  if (loading) {
    return <SubnavLoading />
  }

  return (
    <div style={{ borderBottom: `1px solid ${colors.gray10}` }}>
      <Subnav
        page={subNavPage}
        onTreeNavClickOverride={(treeId) => {
          const groupToGoTo = groups?.find((group) => group.treeIds?.[0] === treeId)
          if ((treeId === 'PRIVATE' && currentTreeId === '') || (groupToGoTo && pathname.includes(groupToGoTo.id))) {
            return
          }

          if (treeId === 'PRIVATE') {
            window.location.assign('/tree/pedigree/?treeId=PRIVATE')
          } else if (groupToGoTo) {
            selectTree?.(treeId)
            window.location.assign(
              `/groups/${groupToGoTo.types.includes('RESEARCHER_TREE') ? 'research-tree' : 'family'}/${groupToGoTo.id}`
            )
          }
        }}
      />
    </div>
  )
}
